import { compressToEncodedURIComponent, decompressFromEncodedURIComponent} from 'lz-string'

const getUrlParam = (paramName) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(paramName)
}

const setUrlParam = (paramName, value) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    urlParams.set(paramName, value)
    window.history.replaceState("", "", '?' + urlParams.toString());
}

const DEFAULT_CSV = `## Quickmaps: The Instant CSV to Geo-Map Tool
# - Click The Map To Add Items.
# - Edit This Textarea To Alter, Update and Delete Items.
# - Share By Copying URL (edit and view-only mode is preserved).
# - Map Title is Editable.
# - '#' Line Prefix is for Comments.

## Some Example Items:
# (Title, Latitude, Longitude, Description)

Bridge To Dumbo, 40.709141393000124, -73.99171829223634, Goes to dumbo - self explanatory.
Decent Park, 40.7152569647158, -73.97558212280275, Pretty nice park on the East River; nice for walks and runs.
One World Trade Center, 40.71299622040226, -74.01320520232115, One World Trade Center is the main building of the rebuilt World Trade Center complex in Lower Manhattan - New York City. https://en.wikipedia.org/wiki/One_World_Trade_Center
One VanderBilt, 40.75293015260061, -73.97860183298263, https://en.wikipedia.org/wiki/One_Vanderbilt`

export const getEdit = () => {
    const edit = getUrlParam('edit')
    if (edit === null) {
        setEdit(true)
        return true
    }
    return getUrlParam('edit') === 'true'
}

export const getInterestingMapMode = () => {
    const interestingMapMode = getUrlParam('interestingMapMode')
    if (interestingMapMode === null) {
        return false
    }
    return getUrlParam('interestingMapMode') === 'true'
}

export const setEdit = (newEdit) => {
    setUrlParam('edit', newEdit)
}

export const getCsvData = () => {
    let storedCsv = getUrlParam('csv');
    if (storedCsv) {
        return decompressFromEncodedURIComponent(storedCsv);
    } else {
        setCsvData(DEFAULT_CSV)
        return DEFAULT_CSV;
    }
}

export const setCsvData = (data) => {
    setUrlParam('csv', compressToEncodedURIComponent(data))
}

export const getTitle = () => {
    let storedTitle = getUrlParam('title');
    if (storedTitle) {
        return storedTitle;
    } else {
        const title = 'My New Map'
        setUrlParam('title', title)
        return title
    }
}

export const setTitle = (newTitle) => {
    setUrlParam('title', newTitle)
    document.title = newTitle
}

export const sendAnalyticsStat = () => {
    const data = {
        payload: {
            website: "8449e985-abac-4474-8763-18664ab76859",
            url: "/",
            referrer: "/",
            hostname: location.hostname,
            language: navigator.language,
            screen: `${screen.width}X${screen.height}`,
        },
        type: "pageview"
    }
    return fetch(
        'https://analytics.xantasoft.com/api/collect',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'User-Agent': navigator.userAgent
            },
            body: JSON.stringify(data)
        })
}